// when document is finished loaded
const CENT_TO_DOLLAR = 100;

if (Shopify.country == 'US') {
  Shopify.locale = 'en';
}

const formatter_Money = new Intl.NumberFormat(`${Shopify.locale}-${Shopify.country}`, {
  style: 'currency',
  currency: `${Shopify.currency.active}`
});

function moneyFormat(amount) {
    return `${formatter_Money.format(amount).replace(/^(\D+)/, '$1 ').replace(/\s+/, ' ')} ${Shopify.currency.active}`
}

document.addEventListener('DOMContentLoaded', function() {
    const $dataPriceEl = $('[data-price]');
    const $dataComparePriceEl = $('[data-compare-price]');
    const currentPriceValue = parseFloat($dataPriceEl.text().match(/[\d,.]+/)[0])
    const dataComparePreProcess = $dataComparePriceEl.text().match(/[\d,.]+/)
    if (!dataComparePreProcess) {
        console.warn('No compare price found, most likely in local dev')
        return
    }

    const currentComparePriceValue = parseFloat($dataComparePriceEl.text().match(/[\d,.]+/))
    console.log(currentComparePriceValue, currentPriceValue)
    $dataPriceEl.text(moneyFormat(currentPriceValue));

    document.addEventListener('brunodl::quantity-change', function(evt) {
        const quantity = parseInt(evt.detail.quantity)

        if (quantity > 1) {
            $dataPriceEl.text(moneyFormat(currentComparePriceValue));
            $dataComparePriceEl.text(moneyFormat(currentPriceValue));
            $dataComparePriceEl.removeClass('visually-hidden')
        } else {
            $dataPriceEl.text(moneyFormat(currentPriceValue));
            $dataComparePriceEl.addClass('visually-hidden')
        }
    })
});
